import angular from 'angular';

import EquipmentService from './equipment.service';
import OrganizationService from './organization.service';
import ResourceService from './resource.service';
import SiteService from './site.service';
import TypeService from './type.service';
import QuickFindService from './quickfind.service';
import LicenseTypeService from './licenseType.service';
import ResourceListService from './resourceList.service';


export default angular
  .module('petroCloud.core', [])
  .service('EquipmentService', EquipmentService)
  .service('LicenseTypeService', LicenseTypeService)
  .service('Organization', OrganizationService)
  .service('ResourceService', ResourceService)
  .service('SiteService', SiteService)
  .service('TypeService', TypeService)
  .service('QuickFindService', QuickFindService)
  .service('ResourceListService', ResourceListService)
  .name;

